module.exports = __webpack_public_path__ + "img/2.a0c99054.jpg";